<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <span>账号：</span>
          <el-input size="small" placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryUserName" @input="getList"></el-input>
        </li>
        <li>
          <span>类型：</span>
          <el-select size="small" v-model="selectType" @change="setTypeNow">
            <el-option v-for="(item, index) in typeData" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column prop="userName" label="账号" min-width="150px"></el-table-column>
        <el-table-column prop="opType" label="类型" min-width="150px"></el-table-column>
        <el-table-column prop="opDesc" label="描述" min-width="150px"></el-table-column>
        <el-table-column prop="opResult" label="结果" min-width="150px"></el-table-column>
        <el-table-column prop="clientIp" label="客户端IP地址" min-width="150px"></el-table-column>
        <el-table-column prop="endTime" label="结束时间" min-width="150px"></el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from './Pagination'
export default {
  name: 'log',
  components: {
    Pagination
  },
  data () {
    return {
      isLoading: true,
      thisModule: [],
      tableData: [{}],
      selectType: 'login',
      typeData: [
        { name: '登录', id: 'login' },
        { name: '操作', id: 'operate' }
      ],
      queryUserName: ''
    }
  },
  created () {
    // 获取模块配置
    let thisModule = this.myOption.requestModule.log.children
    // 缓存模块配置
    this.thisModule = thisModule
    // 调用获取列表函数
    this.getList()
  },
  methods: {
    // 获取列表
    getList () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule[this.selectType].id
        },
        url: this.myOption.requestUrl + this.thisModule[this.selectType].api,
        data: this.qs.stringify({
          userName: this.queryUserName,
          startPage: this.$store.state.user.currentPage,
          pageSize: this.$store.state.user.pageSize
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          let data = res.data.data.data
          for (let i = 0, r = data.length; i < r; i++) {
            data[i].opType = data[i].opType === 1 ? '登录' : '操作'
            data[i].opResult = data[i].opResult === 1 ? '成功' : '失败'
          }
          this.tableData = data
          this.$store.dispatch('SetPageTotal', res.data.data.totalSize)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 设置当前类型
    setTypeNow () {
      this.$store.dispatch('RestPage')
      this.getList()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Log.vue